import Image from 'next/image'

interface ImageFrameProps {
  src: string
  alt: string
  variant: 'portrait' | 'landscape' | 'square'
  className?: string
  glowColor?: 'blue' | 'purple'
  priority?: boolean
}

export default function ImageFrame({
  src,
  alt,
  variant,
  className = '',
  glowColor = 'blue',
  priority = false,
}: ImageFrameProps) {
  const glowColorClass = glowColor === 'purple' ? 'bg-purple-500/10' : 'bg-blue-500/10'
  
  // Aspect ratio mapping
  const aspectRatioClass = {
    portrait: 'aspect-[2/3]',
    landscape: 'aspect-[3/2]',
    square: 'aspect-square',
  }[variant]

  // Max width per variant
  const maxWidthClass = {
    portrait: 'max-w-[420px] md:max-w-[520px]',
    landscape: 'max-w-[980px]',
    square: 'max-w-[640px]',
  }[variant]

  return (
    <div className={`relative overflow-visible mx-auto ${maxWidthClass} ${className}`}>
      {/* Subtle glow effect */}
      <div className={`absolute inset-0 ${glowColorClass} rounded-[24px] blur-xl -z-10`} />
      
      {/* Frame container */}
      <div className="relative border border-white/10 bg-gray-900 rounded-[24px] p-4 md:p-6 shadow-2xl">
        {/* Image container with fixed aspect ratio and padding */}
        <div className={`relative w-full ${aspectRatioClass} bg-gray-950/50 p-2`}>
          <Image
            src={src}
            alt={alt}
            fill
            className="object-contain"
            priority={priority}
            sizes={
              variant === 'portrait'
                ? '(max-width: 768px) 92vw, 520px'
                : variant === 'landscape'
                ? '(max-width: 1024px) 92vw, 980px'
                : '(max-width: 768px) 92vw, 640px'
            }
            unoptimized
            onError={(e) => {
              console.error('Image failed to load:', src)
            }}
          />
        </div>
      </div>
    </div>
  )
}

